module.exports = function() {
  return new Worker(__webpack_public_path__ + "9b7aa79e5175738d5587.worker.js");
};